/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

// Self-hosted fonts via Fontsource
import "@fontsource-variable/inter";
import "@fontsource/instrument-serif";

import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const posthogKey = process.env.PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.PUBLIC_POSTHOG_HOST;

// Warn if PostHog key is not configured
if (!posthogKey) {
	console.warn(
		"PostHog key (PUBLIC_POSTHOG_KEY) is not configured. Analytics will be disabled.",
	);
}

const elem = document.body;

// Conditionally wrap with PostHogProvider only if key is available
const app = posthogKey ? (
	<StrictMode>
		<PostHogProvider apiKey={posthogKey} options={{ api_host: posthogHost, opt_in_site_apps: true }}>
			<App />
		</PostHogProvider>
	</StrictMode>
) : (
	<StrictMode>
		<App />
	</StrictMode>
);

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	if (!import.meta.hot.data.root) {
		import.meta.hot.data.root = createRoot(elem);
	}
	const root = import.meta.hot.data.root;
	root.render(app);
} else {
	// The hot module reloading API is not available in production.
	createRoot(elem).render(app);
}
